const filterPatients = (patients, searchInput) => {
  return patients.filter((patient) => patient.name?.toLowerCase().includes(searchInput.toLowerCase()));
};

export default filterPatients;
